"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.track = exports.useIsPendoAvailable = void 0;
const react_1 = require("react");
const useIsPendoAvailable = () => {
    const [isPendoAvailable, setIsPendoAvailable] = (0, react_1.useState)(false);
    const resetCheckPendo = () => {
        setIsPendoAvailable(false);
    };
    (0, react_1.useEffect)(() => {
        if (!isPendoAvailable && window.pendo) {
            if (window.pendo.isReady && window.pendo.isReady()) {
                setIsPendoAvailable(true);
            }
            else if (window.pendo.events && window.pendo.events.ready) {
                window.pendo.events.ready(() => {
                    setIsPendoAvailable(true);
                });
            }
        }
    }, [isPendoAvailable]);
    return { isPendoAvailable, resetCheckPendo };
};
exports.useIsPendoAvailable = useIsPendoAvailable;
const track = (name, metaData) => {
    try {
        window.pendo?.track(name, metaData);
    }
    catch {
        // pendo track fails silently
    }
};
exports.track = track;
//# sourceMappingURL=usePendo.js.map